(function() {
    if (window.__customSellingPlanFieldsetInitialized) {
        return;
    }

    window.__customSellingPlanFieldsetInitialized = true;

    var utilityColorCache = {};
    var utilityProbe = null;

    function formatMoney(amount, locale, currency) {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }

    function formatNumber(amount, locale) {
        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: 2
        }).format(amount);
    }

    function getUtilityProbe() {
        if (!document.body) {
            return null;
        }

        if (utilityProbe) {
            return utilityProbe;
        }

        utilityProbe = document.createElement('div');
        utilityProbe.setAttribute('aria-hidden', 'true');
        utilityProbe.style.position = 'absolute';
        utilityProbe.style.visibility = 'hidden';
        utilityProbe.style.pointerEvents = 'none';
        utilityProbe.style.width = '0';
        utilityProbe.style.height = '0';
        utilityProbe.style.overflow = 'hidden';
        document.body.appendChild(utilityProbe);

        return utilityProbe;
    }

    function resolveUtilityColor(classes, property) {
        var cacheKey = classes + '::' + property;
        var probe;

        if (!classes) {
            return '';
        }

        if (utilityColorCache[cacheKey]) {
            return utilityColorCache[cacheKey];
        }

        probe = getUtilityProbe();

        if (!probe) {
            return '';
        }

        probe.className = classes;
        var resolvedValue = window.getComputedStyle(probe)[property];
        utilityColorCache[cacheKey] = resolvedValue;
        probe.className = '';

        return resolvedValue;
    }

    function getBaseProductBgClass(root) {
        return Array.prototype.find.call(root.classList, function(className) {
            return /^bg-products-[^/]+$/.test(className);
        }) || '';
    }

    function applyThemeAccent(root) {
        var baseBgClass = getBaseProductBgClass(root);

        if (!baseBgClass) {
            return;
        }

        var colorKey = baseBgClass.replace('bg-products-', '');
        var accentBg = resolveUtilityColor(baseBgClass, 'backgroundColor');
        var accentSoft = resolveUtilityColor(baseBgClass + '/20', 'backgroundColor');
        var accentHover = resolveUtilityColor(baseBgClass + '/30', 'backgroundColor');
        var accentTint = resolveUtilityColor(baseBgClass + '/10', 'backgroundColor');
        var accentText = resolveUtilityColor('text-products-' + colorKey, 'color');
        var accentBorder = resolveUtilityColor('border-products-' + colorKey, 'borderTopColor');

        if (accentBg) {
            root.style.setProperty('--custom-sp-color-accent', accentBg);
        }

        if (accentSoft) {
            root.style.setProperty('--custom-sp-color-accent-soft', accentSoft);
        }

        if (accentHover) {
            root.style.setProperty('--custom-sp-color-accent-hover', accentHover);
        }

        if (accentTint) {
            root.style.setProperty('--custom-sp-color-accent-tint', accentTint);
        }

        if (accentText) {
            root.style.setProperty('--custom-sp-color-accent-text', accentText);
        }

        if (accentBorder) {
            root.style.setProperty('--custom-sp-color-accent-border', accentBorder);
            root.style.setProperty('--custom-sp-color-accent', accentBorder);
        }
    }

    function markThemeAccentReady(root) {
        if (!root) {
            return;
        }

        root.classList.remove('custom-selling-plan-fieldset--accent-pending');
        root.classList.add('custom-selling-plan-fieldset--accent-ready');
    }

    function initThemeAccents(scope) {
        scope.querySelectorAll('[data-custom-selling-plan-root]').forEach(function(root) {
            applyThemeAccent(root);
            markThemeAccentReady(root);
        });
    }

    function setOldPrice(wrapper, amount, locale, currency) {
        if (!wrapper) {
            return;
        }

        var valueEl = wrapper.querySelector('[data-custom-old-price-value]');

        if (amount === null) {
            wrapper.hidden = true;
            if (valueEl) {
                valueEl.textContent = '';
            }
            return;
        }

        if (valueEl) {
            valueEl.textContent = formatMoney(amount, locale, currency);
        }
        wrapper.hidden = false;
    }

    function updateCardPrices(root) {
        var basePriceCents = parseInt(root.dataset.basePrice || '0', 10);
        var locale = document.documentElement.lang || root.dataset.locale || 'de-DE';
        var currency = root.dataset.currency || document.documentElement.dataset.currency || 'EUR';

        root.querySelectorAll('[data-custom-selling-plan-card]').forEach(function(card) {
            var quantity = parseInt(card.dataset.quantity || '1', 10);
            var discount = parseInt(card.dataset.discount || '0', 10);
            var totalCents = Math.floor(basePriceCents * quantity * (100 - discount) / 100);
            var unitAmount = totalCents / Math.max(quantity, 1) / 100;
            var saveAmount = Math.floor(basePriceCents * quantity * discount / 100) / 100;
            var saveLabel = card.querySelector('[data-custom-save-amount]');
            var unitLabel = card.querySelector('[data-custom-price-unit]');

            if (unitLabel) {
                unitLabel.textContent = formatMoney(unitAmount, locale, currency);
            }

            if (saveLabel) {
                if (discount > 0) {
                    saveLabel.textContent = root.dataset.saveLabelTemplate.replace('__amount__', formatMoney(saveAmount, locale, currency));
                } else {
                    saveLabel.textContent = '';
                }
            }

            var unitPriceCents = parseInt(root.dataset.unitPrice || '0', 10);
            var portionPriceEl = card.querySelector('[data-custom-price-portion]');
            if (portionPriceEl && unitPriceCents > 0) {
                var discountedPortionAmount = Math.floor(unitPriceCents * (100 - discount) / 100) / 100;
                portionPriceEl.textContent = formatMoney(discountedPortionAmount, locale, currency);
            }

            var oldPriceUnitEl = card.querySelector('[data-custom-old-price-unit]');
            var oldPricePortionEl = card.querySelector('[data-custom-old-price-portion]');
            setOldPrice(oldPriceUnitEl, discount > 0 && basePriceCents > 0 ? basePriceCents / 100 : null, locale, currency);
            setOldPrice(oldPricePortionEl, discount > 0 && unitPriceCents > 0 ? unitPriceCents / 100 : null, locale, currency);

            var nutrientBase = parseFloat(root.dataset.nutrientValue || '0');
            var nutrientValueEl = card.querySelector('[data-custom-nutrient-value]');
            if (nutrientValueEl && nutrientBase > 0) {
                nutrientValueEl.textContent = formatNumber(nutrientBase * quantity, locale);
            }
        });
    }

    function dispatchQty(root, quantity) {
        root.dispatchEvent(new CustomEvent('custom-selling-plan-qty', {
            bubbles: true,
            detail: {
                qty: quantity
            }
        }));
    }

    function parseWeightGrams(text) {
        var match = String(text || '').trim().match(/^(\d+(?:[.,]\d+)*)\s*(kg|kilogramm|gramm|gr|g)$/i);
        if (!match) {
            return null;
        }

        var numberText = match[1];
        var isKg = /^k/i.test(match[2]);
        var grams;

        if (!isKg && /^[1-9]\d{0,2}(?:[.,]\d{3})+$/.test(numberText)) {
            grams = parseFloat(numberText.replace(/[.,]/g, ''));
        } else if (/^\d+(?:[.,]\d+)?$/.test(numberText)) {
            var value = parseFloat(numberText.replace(',', '.'));
            grams = isKg ? Math.round(value * 1000) : value;
        } else {
            return null;
        }

        return isFinite(grams) && grams > 0 ? grams : null;
    }

    function formatWeight(grams, locale) {
        var rounded = Math.round(grams);
        if (rounded < 1000) {
            return rounded + ' g';
        }
        return formatNumber(rounded / 1000, locale) + ' kg';
    }

    function updatePricePerKg(root, card) {
        var el = root.querySelector('[data-custom-price-per-kg]');
        if (!el) {
            return;
        }

        if (root._customWeightGrams === undefined) {
            root._customWeightGrams = parseWeightGrams(root.dataset.sizeText);
        }

        var grams = root._customWeightGrams;
        var locale = document.documentElement.lang || root.dataset.locale || 'de-DE';
        var currency = root.dataset.currency || document.documentElement.dataset.currency || 'EUR';
        var basePriceCents = parseInt(root.dataset.basePrice || '0', 10);
        var quantity = parseInt(card.dataset.quantity || '1', 10) || 1;
        var discount = parseInt(card.dataset.discount || '0', 10);
        var totalCents = Math.floor(basePriceCents * quantity * (100 - discount) / 100);

        if (!grams || !(basePriceCents > 0) || !(totalCents > 0)) {
            el.textContent = '';
            el.hidden = true;
            return;
        }

        var totalGrams = grams * quantity;
        var perKg = (totalCents / 100) * 1000 / totalGrams;

        el.textContent = formatMoney(perKg, locale, currency) + ' ' + (root.dataset.perLabel || 'per') +
            ' kg (' + formatMoney(totalCents / 100, locale, currency) + ' / ' + formatWeight(totalGrams, locale) + ')';
        el.hidden = false;
    }

    // Multiple subscription cards ("subscription only" buy box): keep the legacy
    // radio (read on add to cart) and its labels on the active card's plan.
    function syncLegacySubscriptionPlan(root, card, subscriptionInput, subscriptionContainer, sellingPlanId) {
        if (!sellingPlanId || subscriptionInput.value === sellingPlanId) {
            return;
        }

        var titleEl = card.querySelector('.custom-selling-plan-card__title');
        var planName = titleEl ? titleEl.textContent.trim() : '';
        var legacyLabel = subscriptionInput.id ? root.querySelector('label[for="' + subscriptionInput.id + '"]') : null;
        var legacyName = subscriptionContainer ? subscriptionContainer.querySelector('.selected-selling-plan-name') : null;

        subscriptionInput.value = sellingPlanId;
        subscriptionInput.id = sellingPlanId;
        if (legacyLabel) {
            legacyLabel.setAttribute('for', sellingPlanId);
            if (planName) legacyLabel.textContent = planName;
        }
        if (legacyName && planName) legacyName.textContent = planName;
    }
    function syncBuyBoxTagPrice(root) {
        if (!root) {
            return;
        }

        var targets = document.querySelectorAll('[data-buy-box-tag-price]');

        if (!targets.length) {
            return;
        }

        var activeCard = root.querySelector('[data-custom-selling-plan-card].is-active') ||
            root.querySelector('[data-custom-selling-plan-card]');

        if (!activeCard) {
            return;
        }

        var portionPriceEl = activeCard.querySelector('[data-custom-price-portion]');

        if (!portionPriceEl) {
            return;
        }

        var portionPrice = (portionPriceEl.textContent || '').trim();

        if (!portionPrice) {
            return;
        }

        targets.forEach(function(target) {
            target.textContent = portionPrice;
        });
    }

    function syncState(root, card) {
        var mode = card.dataset.mode;
        var quantity = card.dataset.quantity || '1';
        var parsedQuantity = parseInt(quantity, 10) || 1;
        var sellingPlanId = card.dataset.sellingPlanId || '';
        var oneTimeInput = root.querySelector('.custom-selling-plan-legacy-one-time');
        var subscriptionInput = root.querySelector('.custom-selling-plan-legacy-subscription');
        var oneTimeContainer = root.querySelector('.js-single-purchase');
        var subscriptionContainer = root.querySelector('.js-plan-purchase');
        var productForm = root.closest('.product-form');
        var hiddenSellingPlanInput = productForm ? productForm.querySelector('input[name="selling_plan"]') : null;

        root.querySelectorAll('[data-custom-selling-plan-card]').forEach(function(item) {
            item.classList.toggle('is-active', item === card);
        });

        root.querySelectorAll('.custom-selling-plan-legacy-qty').forEach(function(input) {
            input.value = quantity;
            input.setAttribute('value', quantity);
        });

        dispatchQty(root, parsedQuantity);

        if (mode === 'subscription') {
            if (subscriptionInput) {
                syncLegacySubscriptionPlan(root, card, subscriptionInput, subscriptionContainer, sellingPlanId);
                subscriptionInput.checked = true;
            }
            if (oneTimeInput) {
                oneTimeInput.checked = false;
            }
            if (subscriptionContainer) {
                subscriptionContainer.classList.add('active');
            }
            if (oneTimeContainer) {
                oneTimeContainer.classList.remove('active');
            }
            if (hiddenSellingPlanInput) {
                hiddenSellingPlanInput.value = sellingPlanId;
            }
        } else {
            if (oneTimeInput) {
                oneTimeInput.checked = true;
            }
            if (subscriptionInput) {
                subscriptionInput.checked = false;
            }
            if (oneTimeContainer) {
                oneTimeContainer.classList.add('active');
            }
            if (subscriptionContainer) {
                subscriptionContainer.classList.remove('active');
            }
            if (hiddenSellingPlanInput) {
                hiddenSellingPlanInput.value = '';
            }
        }

        updatePricePerKg(root, card);
        syncBuyBoxTagPrice(root);
    }

    function updateOneTimeExtraHeight(section) {
        var extra = section.querySelector('[data-custom-one-time-extra]');

        if (!extra) {
            return;
        }

        extra.style.setProperty('--custom-one-time-extra-height', extra.scrollHeight + 1 + 'px');
    }

    function setOneTimeCollapsed(section, collapsed, root) {
        var toggleTargets = section.querySelectorAll('[data-custom-one-time-toggle]');
        var firstOneTimeCard = section.querySelector('[data-custom-selling-plan-card][data-mode="one-time"][data-quantity="1"]');

        updateOneTimeExtraHeight(section);

        section.classList.toggle('is-collapsed', collapsed);

        toggleTargets.forEach(function(toggle) {
            toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });

        // Collapsing only hides the extra one-time cards. If one of them is the
        // active card, move the selection to the primary one-time card;
        // otherwise leave the current selection (e.g. subscription) untouched.
        if (collapsed && firstOneTimeCard) {
            var activeCard = section.querySelector('[data-custom-one-time-extra] [data-custom-selling-plan-card].is-active');

            if (activeCard) {
                syncState(root, firstOneTimeCard);
            }
        }
    }

    function bindOneTimeCollapse(root) {
        var section = root.querySelector('[data-custom-one-time-section]');

        if (!section || section.dataset.customOneTimeCollapseReady === 'true') {
            return;
        }

        section.dataset.customOneTimeCollapseReady = 'true';
        updateOneTimeExtraHeight(section);

        section.querySelectorAll('[data-custom-one-time-toggle]').forEach(function(toggle) {
            var handler = function(event) {
                event.preventDefault();
                event.stopPropagation();
                setOneTimeCollapsed(section, !section.classList.contains('is-collapsed'), root);
            };

            toggle.addEventListener('click', handler);
            toggle.addEventListener('keydown', function(event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    handler(event);
                }
            });
        });

        window.addEventListener('resize', function() {
            updateOneTimeExtraHeight(section);
        });

        if (section.dataset.defaultCollapsed === 'true') {
            setOneTimeCollapsed(section, true, root);
        }
    }

    function initCountdown(root) {
        var bar = root.querySelector('[data-selling-plan-countdown]');

        if (!bar || bar.dataset.spCountdownReady === 'true') {
            return;
        }

        bar.dataset.spCountdownReady = 'true';

        var endTimestamp = parseInt(bar.dataset.end || '0', 10) * 1000;
        var ddEl = bar.querySelector('[data-sp-countdown-dd]');
        var hhEl = bar.querySelector('[data-sp-countdown-hh]');
        var mmEl = bar.querySelector('[data-sp-countdown-mm]');
        var ssEl = bar.querySelector('[data-sp-countdown-ss]');

        if (!endTimestamp || !hhEl || !mmEl || !ssEl) {
            return;
        }

        function pad(n) {
            return n < 10 ? '0' + n : String(n);
        }

        function tick() {
            var remaining = Math.max(0, Math.floor((endTimestamp - Date.now()) / 1000));
            var dd = Math.floor(remaining / 86400);
            var hh = Math.floor((remaining % 86400) / 3600);
            var mm = Math.floor((remaining % 3600) / 60);
            var ss = remaining % 60;

            if (ddEl) { ddEl.textContent = pad(dd); }
            hhEl.textContent = pad(hh);
            mmEl.textContent = pad(mm);
            ssEl.textContent = pad(ss);

            if (remaining <= 0) {
                bar?.remove();
                clearInterval(timer);
            }
        }

        tick();
        var timer = setInterval(tick, 1000);
    }
    function setSubscriptionOptionByUrl(){
        const params = new URLSearchParams(window.location.search);
        const targetSubscription = params.get('subscription_default');
        if (!targetSubscription || targetSubscription === 'false') return;
        const card = document.querySelector('[data-custom-selling-plan-card][data-mode="subscription"]');
        if (card && !card.classList.contains('is-active')) card.click();
    }

    function initRoot(root) {
        if (root.dataset.afSellingPlanReady === 'true') {
            return;
        }

        root.dataset.afSellingPlanReady = 'true';
        updateCardPrices(root);
        bindOneTimeCollapse(root);
        initCountdown(root);

        var defaultMode = root.dataset.defaultMode || 'one-time';
        var defaultCard = root.querySelector('[data-custom-selling-plan-card][data-mode="' + defaultMode + '"]') || root.querySelector('[data-custom-selling-plan-card]');

        root.querySelectorAll('[data-custom-selling-plan-card]').forEach(function(card) {
            card.addEventListener('click', function() {
                syncState(root, card);
            });
        });

        if (defaultCard) {
            syncState(root, defaultCard);
        }

        setSubscriptionOptionByUrl();

        // This deferred script runs before bundle.js starts Alpine, so the
        // qty event above fires before the x-on:custom-selling-plan-qty
        // listeners exist (the buy box would keep qty 1 for a subscription
        // default). Re-send the active card's quantity once Alpine is ready.
        document.addEventListener('alpine:initialized', function() {
            var activeCard = root.querySelector('[data-custom-selling-plan-card].is-active');

            if (activeCard) {
                dispatchQty(root, parseInt(activeCard.dataset.quantity || '1', 10) || 1);
            }
        }, { once: true });
    }

    function initAll(scope) {
        scope.querySelectorAll('[data-custom-selling-plan-root]').forEach(initRoot);
    }

    // Public hook for markup swapped in via AJAX (e.g. the landing package
    // switcher in landing-greens.js). initRoot is idempotent, so this is safe
    // to call alongside the MutationObserver below.
    window.CustomSellingPlanFieldset = {
        init: function(scope) {
            scope = scope || document;
            if (scope.matches && scope.matches('[data-custom-selling-plan-root]')) {
                applyThemeAccent(scope);
                markThemeAccentReady(scope);
                initRoot(scope);
                return;
            }
            initThemeAccents(scope);
            initAll(scope);
        }
    };

    initThemeAccents(document);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initAll(document);
        });
    } else {
        initAll(document);
    }

    new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) {
                    return;
                }

                if (node.matches && node.matches('[data-custom-selling-plan-root]')) {
                    applyThemeAccent(node);
                    markThemeAccentReady(node);
                    initRoot(node);
                    return;
                }

                if (node.querySelectorAll) {
                    initThemeAccents(node);
                    initAll(node);
                }
            });
        });
    }).observe(document.documentElement, { childList: true, subtree: true });
})();